import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Input, Table } from 'semantic-ui-react';
import TimeUtils from '../../../helper/TimeUtils';
import { setNewTimeString } from '../../../actions/editTableActions';

class TimecodeInput extends Component {
  constructor(props) {
    super(props);

    this.h_input = React.createRef();
    this.m_input = React.createRef();
    this.s_input = React.createRef();
    this.f_input = React.createRef();

    this.state = {
      selectIndex: 0,
      orgData: this.props.orgData,
      first: null,
      inputEnable: false,
      h: null,
      m: null,
      s: null,
      f: null,
      orgTimeString: '',
    };

    this.updateTimeString = this.updateTimeString.bind(this);

    //檢查frame數量
    this.checkFrameCount = this.checkFrameCount.bind(this);
  }

  //檢查間距
  checkFrameCount() {
    const { h, m, s, f, orgTimeString } = this.state;

    let newTitleString = `${this.h_input.value}:${this.m_input.value}:${this.s_input.value}.${this.f_input.value}`;

    const { type } = this.props;
    if (type === 'firstNewTime') {
      //上傳新時間
      this.props.setNewTimeString(newTitleString);
    }

    if (type === 'differenceTime') {
      //上傳新時間
      this.props.setNewTimeString(newTitleString);
    }
  }

  componentWillUnmount() {}

  async componentDidMount() {
    try { 
      await this.setState({
        orgData: this.props.orgData,
        selectIndex: this.props.selectIndex,
      });

      await this.updateTimeString();

      //第一次進來的 就是差距
      const { type } = this.props;
      if (type === 'firstNewTime') {
        const { h, m, s, f } = this.state;
        this.setState({
          orgTimeString: `${h}:${m}:${s}.${f}`,
        });
      }
    } catch (err) {
      console.log(`componentDidMount ${err}`);
    }
  }
  async updateTimeString() {
    try {
      const { type } = this.props;
      const { data } = this.props.editTable;

      if (data !== null) {
        if (type !== 'differenceTime') {
          const { orgData } = this.state;
          const { In } = orgData;
          let timeArray1 = In.split('.');
          let timeArray2 = timeArray1[0].split(':');

          this.setState({
            h: timeArray2[0],
            m: timeArray2[1],
            s: timeArray2[2],
            f: timeArray1[1],
          });
        }
      }
    } catch (err) {
      console.log(`componentDidMount ${err}`);
    }
  }
  async componentWillReceiveProps(nextProps) {
    await this.setState({
      orgData: nextProps.orgData,
      selectIndex: nextProps.selectIndex,
    });
    this.updateTimeString();
  }

  m_input_moveTonext(event) {
    //進行檢查
    if (parseFloat(event.target.value) >= 0) {
      this.checkFrameCount();
    }

    //移動到下一個
    if (this.h_input.value.length === 2) {
      this.m_input.focus();  
      this.setState({ m: "" });
    }
  }

  s_input_moveTonext(event) {
    //進行檢查
    if (parseFloat(event.target.value) >= 0) {
      this.checkFrameCount();
    }

    //移動到下一個
    if (this.m_input.value.length === 2) { 
      this.s_input.focus();
      this.setState({ s: "" });
    }
  }

  f_input_moveTonext(event) {
    //進行檢查
    if (parseFloat(event.target.value) >= 0) {
      this.checkFrameCount();
    }

    //移動到下一個
    if (this.s_input.value.length === 2) { 
      this.f_input.focus();
      this.setState({ f: "" });
    }
  }

  render() {
    const { type } = this.props;
    const { h, m, s, f, selectIndex } = this.state;
    // In(pin):"00:00:00.16"
    // Out(pin):"00:00:02.5"
    /**
         * 5種顯示
         firstOrgTime
         secondOrgTime

         differenceTime

         firstNewTime
         secondNewTime
         */

    let mainVie;
    // if(type === "differenceTime"){
    //
    //     let enable = false;
    //     if(parseFloat(selectIndex) === 0  ){
    //         enable = true;
    //     }
    //
    //     mainVie = <div  className=' '>
    //
    //         <input disabled={enable}    style={{width:'22px'}} value={h}
    //                  onChange={  event => this.setState({ h: event.target.value })} />
    //
    //         <span className="px-1">:</span>
    //
    //         <input disabled={enable}   style={{width:'22px'}} value={m}
    //                 onChange={  event => this.setState({ m: event.target.value })} />
    //
    //         <span className="px-1">:</span>
    //
    //         <input disabled={enable}   style={{width:'22px'}} value={s}
    //                 onChange={  event => this.setState({ s: event.target.value })} />
    //
    //         <span className="px-1">:</span>
    //
    //         <input disabled={enable}  style={{width:'22px'}} value={f}
    //                onChange={  event => this.setState({ f: event.target.value })} />
    //
    //     </div>;
    //
    // }else{
    //
    //
    // }

    //
    let enable = false;
    if (
      type === 'firstOrgTime' ||
      type === 'secondOrgTime' ||
      type === 'secondNewTime'
    ) {
      enable = true;
    } else if (type === 'firstNewTime') {
      if (parseFloat(selectIndex) === 1) {
        enable = true;
      }
    } else if (type === 'differenceTime') {
      if (parseFloat(selectIndex) === 0) {
        enable = true;
      }
    }
    mainVie = (
      <div className=' '>
        <input
          ref={(ref) => (this.h_input = ref)}
          disabled={enable}
          style={{ width: '22px' }}
          value={h}
          onChange={(event) => {
            this.setState({ h: event.target.value });

            this.m_input_moveTonext(event);
          }}
        />

        <span className='px-1'>:</span>

        <input
          id='m_input'
          ref={(ref) => (this.m_input = ref)}
          disabled={enable}
          style={{ width: '22px' }}
          value={m}
          onChange={(event) => {
            this.setState({ m: event.target.value });

            this.s_input_moveTonext(event);
          }}
        />

        <span className='px-1'>:</span>

        <input
          id='s_input'
          ref={(ref) => (this.s_input = ref)}
          disabled={enable}
          style={{ width: '22px' }}
          value={s}
          onChange={(event) => {
            this.setState({ s: event.target.value });

            this.f_input_moveTonext(event);
          }}
        />

        <span className='px-1'>:</span>

        <input
          id='f_input'
          ref={(ref) => (this.f_input = ref)}
          disabled={enable}
          style={{ width: '22px' }}
          value={f}
          onChange={(event) => {
            this.setState({ f: event.target.value });

            //進行檢查
            if (parseFloat(event.target.value) >= 0) {
              this.checkFrameCount();
            }
          }}
        />
      </div>
    );

    return mainVie;
  }
}

TimecodeInput.propTypes = {};

const mapStateToProps = (state) => ({
  editTable: state.editTable,
  transOperation: state.transOperation,
});

export default connect(mapStateToProps, { setNewTimeString })(
  withRouter(TimecodeInput)
);



// WEBPACK FOOTER //
// ./src/components/layout/TimecodeShift/TimecodeInput.js